import ModalConfigurationGeneral from './ModalConfigurationGeneral'

export default ModalConfigurationGeneral
